/*
Pulls
 */

const name = 'Pulls'
const id = 'ZrXygTWk9v9BPiePGUZr'

export default {
  name,
  id
}
